export enum Constants {
	id = 'first_name',
	name = 'FirstName',
}
